<template>
  <div class="content-gallery">
    <h2 class="content-gallery__title" v-html="title" v-if="content.title"></h2>
    <masonry
      class="content-gallery__items"
      :cols="{default: 2, 768: 1}"
      :gutter="{default: '30px', 768: '15px'}"
    >
      <div
        class="content-gallery__item"
        v-for="(item, index) in items"
        :key="`item-${index}`"
        @click.prevent.stop="handleClick(item)"
      >
        <img :src="item.url" :alt="item.alt" />
      </div>
    </masonry>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ContentGallery',
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  computed: {
    title () {
      return this.content.title
    },
    items () {
      return this.content.list
    }
  },
  methods: {
    ...mapActions('modals', [
      'updateCurrentImage'
    ]),
    handleClick (item) {
      this.updateCurrentImage({ url: item.url, alt: item.alt })
    }
  }
}
</script>

<style lang="scss">
  .content-gallery{

    // Title

    &__title{
      @include title;
      margin: 0;
      color: white;
      line-height: 1.2;
      margin-bottom: layout("spacing")*2;
      font-family: get($font-families, "secondary");
    }

    // Item

    &__item{
      @include media("small"){
        font-size: 1.6rem;
        margin-bottom: layout("spacing")/2;
      }
      @include media("medium-large"){
        font-size: 1.8rem;
        margin-bottom: layout("spacing");
      }

      color: white;
      cursor: pointer;

      img{
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: top center;
      }
    }
  }
</style>
